// removed by extract-text-webpack-plugin
module.exports = {"List":"_3x2Czp0p9cwqjMu-_xByzu","Header":"rbhDq2Adu6d2m4wAQiONw","nothing":"_3BAdS2r5JvQx32vxmY4f31","green":"_2Ww9fqPgQkLsy3U24kGtvz","red":"Ibk4PR2w-2rImY2uC-0C-","Row":"_1MUtTU1fSE1kX98wC2essf"};


//////////////////
// WEBPACK FOOTER
// ./src/lists/DashboardList/index.css
// module id = 840
// module chunks = 0